import { createSelector } from 'reselect';
import lowercase from 'lodash/lowerCase';

const getPublicationsAndDataList = (state) => state.publicationsAndData.list;

const getPublicationsAndDataTitles = createSelector(
  getPublicationsAndDataList,
  (publicationsAndData) => (
    publicationsAndData.sort((a, b) => a.position - b.position).map(a => (
      {
        label: a.title,
        path: `/publications-data/${lowercase(a.title).replace(/ /g, '-')}`
      }
    ))
  )
);

export { getPublicationsAndDataTitles };



// WEBPACK FOOTER //
// ./app/selectors/publicationsAndData.js